(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .controller('BatchJobsController', BatchJobsController);

    BatchJobsController.$inject = ['BatchJobs', '$interval', 'ParseLinks', 'paginationConstants'];

    function BatchJobsController(BatchJobs, $interval, ParseLinks, paginationConstants) {

        var vm = this;

        vm.batchJobs = [];
        vm.etat = null;
        vm.isLoading = false;
        vm.links = {};
        vm.page = 0;
        vm.summary = {};
        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.refresh = refresh;
        vm.search = search;

        refresh();

        // Rafraichissement automatique toutes les 60s.
        $interval(refresh, 60000);

        function loadAll() {
            if (vm.isLoading) {
                return;
            }
            vm.isLoading = true;
            BatchJobs.query({
                page: vm.page,
                size: paginationConstants.itemsPerPage,
                etat: resolveEtatFilter()
            }, onSuccess, onError);
        }

        function loadPage(page) {
            if (angular.isDefined(page) && page !== vm.page) {
                vm.page = page;
                loadAll();
            }
        }

        function refresh() {
            vm.page = 0;
            vm.links = {};
            vm.totalItems = 0;
            vm.batchJobs = [];
            loadSummary();
            loadAll();
        }

        function search() {
            refresh();
        }

        function loadSummary() {
            BatchJobs.summary({
                etat: resolveEtatFilter()
            }, function(result) {
                vm.summary = result;
            });
        }

        function resolveEtatFilter() {
            return vm.etat ? vm.etat : null;
        }

        function onSuccess(result, headers) {
            var linkHeader = headers('link');
            vm.links = linkHeader ? ParseLinks.parse(linkHeader) : {};
            vm.totalItems = headers('X-Total-Count');
            vm.batchJobs = vm.batchJobs.concat(result);
            vm.isLoading = false;
        }

        function onError() {
            vm.isLoading = false;
        }
    }

})();
